import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 18h16v14H8V18zM8 4h16v14H8V4zM8 32h16v14H8V32zM8 46h16v14H8V46zM24 46h16v14H24V46zM24 18h16v14H24V18zM40 18h16v14H40V18z",
      stroke: "#fff",
      fill: "#fff",
      "stroke-width": "4",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18 52h12v2H18v-2zM13 24h37v2H13v-2z",
      fill: "#55acba",
      stroke: "#55acba",
      "stroke-width": "1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11 21h10v8H11v-8zM11 7h10v8H11V7zM11 35h10v8H11v-8zM43 21h10v8H43v-8zM27 21h10v8H27v-8zM11 49h10v8H11v-8zM27 49h10v8H27v-8z",
      stroke: "#55acba",
      "stroke-width": "2",
      fill: "#86bc4d",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }